module.exports = __webpack_public_path__ + "static/google_play-a92434690e91085ad62db7e1eb7d1b83.png";